import { createAction } from "@reduxjs/toolkit";
import type { SubmitSurveyCommand } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const submitSurvey = createApiThunk<void, SubmitSurveyCommand>(
  "student/submitSurvey",
  async (payload: SubmitSurveyCommand, { extra: { studentRepository } }) => {
    return studentRepository!.submitSurvey(payload);
  },
);

export const resetSubmitSurvey = createAction("student/resetSubmitSurvey");
